module.exports = __webpack_public_path__ + "media/images/fallback/prize/default-75fab9745e8b43e897e872fefa355394.png";